import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=5d637300&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=ts"
export * from "./ranking.vue?vue&type=script&lang=ts"
import style0 from "./ranking.vue?vue&type=style&index=0&id=5d637300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d637300",
  null
  
)

export default component.exports